module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.4867/images/default-company-avatar.png"